export default "__VITE_ASSET__6d9e8303__"